var map = {
	"./Facebook_20x20.svg": 154,
	"./Instagram_20x20.svg": 155,
	"./Linkedin_20x20.svg": 156,
	"./People/Board_Jonas_Eriksson_web.jpg": 157,
	"./People/CFO_Robert_Karlsson_web.jpg": 158,
	"./People/ceo_Kristoffer_Karlsson_web.jpg": 159,
	"./Seller_contact_example.png": 160,
	"./Seller_order-id_example.png": 161,
	"./SpotinTechnical_desktop.svg": 162,
	"./SpotinTechnical_mobile.svg": 163,
	"./Spotin_SymbolS_Ring_Blue_Big_RGB.png": 164,
	"./Spotin_SymbolS_Ring_Off_White_Big_RGB.png": 165,
	"./Spotin_SymbolS_Ring_Off_White_Small_RGB.png": 166,
	"./Spotin_SymbolS_Square_Off_White_Big_RGB.png": 167,
	"./Stina_goya_scarf_hat.jpg": 168,
	"./bok_amor_towles.png": 169,
	"./bonnier.svg": 170,
	"./chechout_from_shelf.png": 171,
	"./circle_1.svg": 172,
	"./circle_2.svg": 173,
	"./circle_3.svg": 174,
	"./circle_a_new_kind_of_buy.png": 175,
	"./circle_commerce_on_your_terms.png": 176,
	"./circle_simple_integration.png": 177,
	"./circles_content_to_commerce.png": 178,
	"./dollar.svg": 179,
	"./exclusiveOffer.svg": 180,
	"./heart.svg": 181,
	"./little_liffner_TALL_TULIP TOTE_DUSTY_PINK.png": 182,
	"./logo/Spotin_TM_Logo_Blue_Big_RGB.png": 183,
	"./logo/Spotin_TM_Logo_Blue_Small_RGB.png": 110,
	"./logo/Spotin_TM_Logo_Off-Black_Big_RGB.png": 184,
	"./logo/Spotin_TM_Logo_Off-Black_Small_RGB.png": 111,
	"./logo/Spotin_TM_Logo_Off-White_Big_RGB.png": 185,
	"./logo/Spotin_TM_Logo_Off-White_Small_RGB.png": 112,
	"./logo/Spotin_TM_Logo_Sand_Big_RGB.png": 186,
	"./logo/Spotin_TM_Logo_Sand_Small_RGB.png": 113,
	"./logo/Spotin_TM_Logo_True-White_Big_RGB.png": 187,
	"./logo/Spotin_TM_Logo_True-White_Small_RGB.png": 188,
	"./media1.jpg": 189,
	"./media2.jpg": 190,
	"./media3.jpg": 191,
	"./media4.jpg": 192,
	"./monetize_your_content.png": 193,
	"./multiLanguages.svg": 194,
	"./multiPaths.svg": 195,
	"./news1.jpg": 196,
	"./news1.png": 197,
	"./news2.jpg": 198,
	"./news3.jpg": 199,
	"./news4.jpg": 200,
	"./news5.jpg": 201,
	"./news6.jpg": 202,
	"./news7.jpg": 203,
	"./offices_Dhaka.jpg": 204,
	"./offices_Lulea.jpg": 205,
	"./offices_Sthlm.jpg": 206,
	"./orderreference.jpeg": 207,
	"./orderreference.png": 208,
	"./percent.svg": 209,
	"./preOrder.svg": 210,
	"./sneaker.png": 211,
	"./sneaker2.png": 212,
	"./sophiebysophie.svg": 213,
	"./spotin_portal.png": 214,
	"./spotin_portal.svg": 215,
	"./swedish_stockings.png": 216,
	"./timeline.png": 217,
	"./venn_circles.png": 218,
	"./venn_content_commerce.png": 219,
	"./venn_content_commerce.svg": 220,
	"./venn_content_commerce_mobile.png": 221,
	"./venn_content_commerce_mobile.svg": 222,
	"./venn_for_sellers.png": 223,
	"./voguescandinavia.svg": 224
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 261;


//////////////////
// WEBPACK FOOTER
// ./assets/imgs ^\.\/.*$
// module id = 261
// module chunks = 0